import React, { useEffect, useState } from "react";
import { Button, Card, Col, Input, Row } from "reactstrap";
import { data } from "../../View Profile/Component/Data";

const UpdateTradingHour = ({
  values,
  onSave,
  setFieldValue,
  isSubmitting,
  isValid,
  goToPreviousTab,
}) => {
  const [localData, setLocalData] = useState(values.orgTradingHour || []);

  // Watch for changes in values.orgTradingHour and update localData
  useEffect(() => {
    if (values.orgTradingHour) {
      setLocalData(values.orgTradingHour);
    }
  }, [values.orgTradingHour]);
  const [editIndex, setEditIndex] = useState(null); // Track the index of the row being edited
  const [editData, setEditData] = useState(null); // Store the edited data temporarily
  const [newRowData, setNewRowData] = useState(null); // Track newly added row data

  // const handleDelete = (index) => (event) => {
  //   event.preventDefault(); // Prevent form submission
  //   const newData = localData.filter((_, idx) => idx !== index);
  //   setLocalData(newData); // Replace localData with the updated array
  // };
  const handleDelete = (index) => {
    // No need for event.preventDefault() since button type is "button"
    const newData = localData.filter((_, idx) => idx !== index);
    setLocalData(newData);
    
    // Also update Formik state
    setFieldValue("getTradingHours", newData);
  };

  const handleAddRow = (event) => {
    event.preventDefault(); // Prevent form submission

    const newRow = {
      day_of_week: "",
      opening_time: "",
      closing_time: "",
      bar_timing: "",
    };
    setLocalData((prevData) => [...prevData, newRow]); // Add new row to local state
    const newIndex = localData.length; // New row will be the last index
    setEditIndex(newIndex); // Immediately enter edit mode for the new row
    setEditData(newRow); // Pre-fill editData with the new row's data
    setNewRowData(newRow); // Save the new row temporarily
  };

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditData({ ...localData[index] }); // Store the current data for editing
  };

  const handleSave = (event) => {
    event.preventDefault(); // Prevent form submission

    const updatedData = [...localData];
    if (editIndex !== null) {
      updatedData[editIndex] = editData;
    }
    setLocalData(updatedData);
    setEditIndex(null); // Exit edit mode
    setEditData(null);
    setNewRowData(null); // Clear new row data after saving

    setFieldValue("getTradingHours", updatedData); // Update the Formik state directly

    if (onSave) onSave(updatedData); // Update parent with the new trading hours
  };

  const handleCancel = () => {
    if (newRowData) {
      // Remove the unsaved row if it was a newly added row
      setLocalData((prevData) => prevData.slice(0, -1));
    }
    setEditIndex(null); // Exit edit mode without saving
    setEditData(null);
    setNewRowData(null); // Clear new row data if canceled
  };

  const handleInputChange = (e, field) => {
    setEditData({
      ...editData,
      [field]: e.target.value,
    });
  };

  const handleSubmit = () => {
    // Submit the form and trigger onSave with the updated data
    if (onSave) {
      onSave(localData); // Pass the localData to the onSave function
    }
  };

  return (
    <>
      <div className="p-0">
        <Row className="d-none d-md-flex">
          <Col md={2} xs={12} className="text-center text-md-start">
            <h6>Day of Week</h6>
          </Col>
          <Col md={2} xs={12} className="text-center text-md-start">
            <h6>Opening Time</h6>
          </Col>
          <Col md={2} xs={12} className="text-center text-md-start">
            <h6>Closing Time</h6>
          </Col>
          <Col md={4} xs={12} className="text-center text-md-start">
            <h6>Bar Timing</h6>
          </Col>
          <Col md={2} xs={12} className="text-center">
            <h6>Actions</h6>
          </Col>
        </Row>
        <hr />
        {localData.map((item, index) => (
          <Row key={index} className="align-items-center mb-3">
            <Col md={2} xs={12} className="mb-2 mb-md-0">
              {editIndex === index ? (
                <Input
                  type="select"
                  value={editData?.day_of_week || ""}
                  onChange={(e) => handleInputChange(e, "day_of_week")}
                >
                  <option value="" disabled>
                    Select a day
                  </option>
                  <option value="Monday">Monday</option>
                  <option value="Tuesday">Tuesday</option>
                  <option value="Wednesday">Wednesday</option>
                  <option value="Thursday">Thursday</option>
                  <option value="Friday">Friday</option>
                  <option value="Saturday">Saturday</option>
                  <option value="Sunday">Sunday</option>
                </Input>
              ) : (
                <h6 className="text-center text-md-start">
                  {item.day_of_week}
                </h6>
              )}
            </Col>
            <Col md={2} xs={12} className="mb-2 mb-md-0">
              {editIndex === index ? (
                <Input
                  type="time"
                  value={editData?.opening_time || ""}
                  onChange={(e) => handleInputChange(e, "opening_time")}
                />
              ) : (
                <h6 className="text-center text-md-start">
                  {item.opening_time}
                </h6>
              )}
            </Col>
            <Col md={2} xs={12} className="mb-2 mb-md-0">
              {editIndex === index ? (
                <Input
                  type="time"
                  value={editData?.closing_time || ""}
                  onChange={(e) => handleInputChange(e, "closing_time")}
                />
              ) : (
                <h6 className="text-center text-md-start">
                  {item.closing_time}
                </h6>
              )}
            </Col>
            <Col md={4} xs={12} className="mb-2 mb-md-0">
              {editIndex === index ? (
                <Input
                  type="text"
                  value={editData?.bar_timing || ""}
                  onChange={(e) => handleInputChange(e, "bar_timing")}
                />
              ) : (
                <h6 className="text-center text-md-start">{item.bar_timing}</h6>
              )}
            </Col>
            <Col md={2} xs={12} className="mb-2 mb-md-0 text-center">
              {editIndex === index ? (
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <button
                    type="button"
                    className="btn btn-sm bg-success text-white"
                    onClick={handleSave}
                  >
                    <i className="ri-save-line"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm bg-danger text-white"
                    onClick={handleCancel}
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>
              ) : (
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <button
                    type="button"
                    className="btn btn-sm bg-info text-white"
                    onClick={() => handleEdit(index)}
                  >
                    <i className="bx bx-edit-alt"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm bg-danger text-white"
                    onClick={() => handleDelete(index)}
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </div>
              )}
            </Col>
          </Row>
        ))}
        <button
          className="btn btn-sm bg-primary text-white mt-2"
          onClick={handleAddRow}
        >
          <i className="ri-add-line"></i> Add Row
        </button>
      </div>
      <div className="d-flex flex-wrap justify-content-end align-items-center text-end mt-3 gap-3">
        <Button
          color="danger"
          onClick={goToPreviousTab}
          // className="w-100 w-md-auto"
        >
          Previous
        </Button>
        <Button
          color="success"
          type="submit"
          disabled={isSubmitting || !isValid}
          onClick={handleSubmit}
          // className="w-100 w-md-auto"
        >
          Submit
        </Button>
      </div>
    </>
  );
};

export default UpdateTradingHour;
